import { LabeledListItem } from "@src/appV2/redesign/components/LabeledListItem";
import { List, ListItemIcon, Text } from "@src/appV2/redesign/system/ui-components";

export function TransfererRulesInfo() {
  return (
    <List>
      <LabeledListItem
        key="hint1"
        divider
        label={<ListItemIcon iconType="patients-filled" />}
        sx={{ paddingX: 6 }}
      >
        <Text semibold variant="h6">
          Alternative to canceling
        </Text>
        <Text variant="body1" color="text.secondary">
          If you transfer a shift and your friend works it, your Clipboard Score will not be
          affected.
        </Text>
      </LabeledListItem>
      <LabeledListItem
        key="hint2"
        divider
        label={<ListItemIcon iconType="triangle-exclamation" />}
        sx={{ paddingX: 6 }}
      >
        <Text semibold variant="h6">
          You lose 30 points if they cancel or No-Show
        </Text>
        <Text variant="body1" color="text.secondary">
          If your transfer recipient cancels or No-Shows, you will lose 30 points.
        </Text>
      </LabeledListItem>

      <LabeledListItem
        key="hint4"
        divider
        label={<ListItemIcon iconType="triangle-exclamation" />}
        sx={{ paddingX: 6 }}
      >
        <Text semibold variant="h6">
          Points go to transfer recipient
        </Text>
        <Text variant="body1" color="text.secondary">
          Only the transfer recipient earns points for completing the shift.
        </Text>
      </LabeledListItem>
    </List>
  );
}
